import SpeedTest from '@te/cdev-web-sdk';

import AnimatedNumber from './animator';
import calcDeg from './calc-deg';
import getResult from './get-result';
import qs from './qs';

import i18n from './i18n';

if (i18n.rtl) {
  document.body.dir = 'rtl';
}

const arcEl = document.querySelector('.test-default-el .js-arc');
const needleEl = document.querySelector('.test-default-el .js-needle');
const startBtnEl = document.querySelector('.test-default-el .js-start');
const statusEl = document.querySelector('.test-default-el .js-status');
const resultsEl = document.querySelector('.test-default-el .results');
const resultEls = {
  download: {
    val: document.querySelector('.test-default-el .js-download-val'),
    unit: document.querySelector('.test-default-el .js-download-unit'),
  },
  upload: {
    val: document.querySelector('.test-default-el .js-upload-val'),
    unit: document.querySelector('.test-default-el .js-upload-unit'),
  },
  latency: {
    val: document.querySelector('.test-default-el .js-latency-val'),
    unit: document.querySelector('.test-default-el .js-latency-unit'),
  },
  jitter: {
    val: document.querySelector('.test-default-el .js-jitter-val'),
    unit: document.querySelector('.test-default-el .js-jitter-unit'),
  },
};

startBtnEl.addEventListener('click', () => {
  if (window.ga) {
    window.ga('send', 'test-start');
  }
});

const availableTests = ['latency', 'jitter', 'download', 'upload'];

export default function setupTest(options) {
  const totalArcLength = arcEl.getTotalLength();
  arcEl.setAttribute('stroke-dasharray', totalArcLength);
  arcEl.setAttribute('stroke-dashoffset', totalArcLength);

  const animator = new AnimatedNumber(0, 0.1);
  animator.on('change', (deg) => {
    needleEl.setAttribute('transform', `rotate(${deg} 160 160)`);
    arcEl.setAttribute('stroke-dashoffset', totalArcLength * (1 - deg / 270));
  });

  startBtnEl.addEventListener('click', () => {
    resultsEl.classList.remove('u-hidden');
    startBtnEl.classList.add('u-hidden');
    statusEl.classList.remove('u-hidden');
    statusEl.textContent = i18n.testing.replace('#{test}', i18n.latency);

    availableTests.forEach((test) => {
      resultEls[test].val.textContent = '--';
      resultEls[test].unit.textContent = '';
    });

    const st = new SpeedTest(options);

    let results;

    let i = 0;
    const frame = () => {
      if (results && !results.inProgress) {
        return;
      }

      requestAnimationFrame(frame);

      if (results) {
        const { unit, val } = getResult(results);

        if (unit === 'kbps' || unit === 'mbps') {
          animator.set(calcDeg(unit === 'kbps' ? val / 1024 : val));
        } else {
          animator.reset();
        }

        if (val === '0.00') {
          return;
        }

        if (i % 10 === 0) {
          resultEls[results.inProgress].val.innerHTML = val;
          resultEls[results.inProgress].unit.innerHTML = i18n[unit];

          if (qs('status') !== 'result') {
            statusEl.textContent = i18n.testing.replace(
              '#{test}',
              i18n[results.inProgress],
            );
          } else {
            const displayResult = unit === 'kbps' || unit === 'mbps';
            statusEl.textContent = displayResult ? `${val} ${i18n[unit]}` : '';
          }
        }
        i += 1;
      }
    };

    requestAnimationFrame(frame);

    st.on('progress', (innerResults) => {
      results = innerResults;
    });

    st.on('test-done', (test, results) => {
      window.parent.postMessage({ type: 'progress', data: results }, '*');

      animator.reset();

      const { unit, val } = getResult(results, test);

      const next = {
        latency: 'download',
        download: 'upload',
      };

      statusEl.textContent = i18n.testing.replace('#{test}', i18n[next[test]]);

      resultEls[test].val.innerHTML = val;
      resultEls[test].unit.innerHTML = i18n[unit];

      if (test === 'latency') {
        const jitterRes = getResult(results, 'jitter');

        resultEls.jitter.val.innerHTML = jitterRes.val;
        resultEls.jitter.unit.innerHTML = i18n[jitterRes.unit];
      }
    });

    st.on('done', (results) => {
      window.parent.postMessage({ type: 'complete', data: results }, '*');

      startBtnEl.classList.remove('u-hidden');
      statusEl.classList.add('u-hidden');
      startBtnEl.textContent = i18n.restart;

      animator.reset();

      if (window.ga) {
        window.ga('send', 'test-end');
      }
    });

    st.on('warning', (code) => {
      window.parent.postMessage({ type: 'warning', code }, '*');
    });

    st.on('test-id', (testId) => {
      window.parent.postMessage({ type: 'test-id', data: testId }, '*');
    });

    st.on('error', (error) => {
      const errorType = (error && error.type) || null;
      const errorCode = 'TEST_FAILED';

      if (errorType && errorType === 'INITIATE_ERROR') {
        const errorMssg = error.message;
        window.parent.postMessage(
          { type: 'warning', code: errorCode, error: errorMssg.toString() },
          '*',
        );

        // Let user know there has been a problem
        statusEl.textContent = i18n.initiateFail;
        startBtnEl.classList.remove('u-hidden');
        startBtnEl.textContent = i18n.restart;
        return;
      }

      const code = typeof error === 'string' ? error : errorCode;
      window.parent.postMessage(
        { type: 'warning', code, error: error.toString() },
        '*',
      );
    });

    st.runSpeedTest();
  });
}



// WEBPACK FOOTER //
// ./src/js/lib/setup-test.js